$(function() {
	
	$("#scroll-to-top").on("click", function () {
	    $(document).scrollTop(0);
	});
	
	$(document).on("scroll", function() {
	    if ($(document).scrollTop() > 20) {
	        $("#scroll-to-top").removeClass("d-none").addClass("d-flex");
	    } else {
	        $("#scroll-to-top").addClass("d-none").removeClass("d-flex");
	    }
	});
	
	$("#main").on("scroll", function() {
	    if ($("#main").scrollTop() > 200) {
	        $(".content-footer").addClass("sticky");
	    } else {
	        $(".content-footer").removeClass("sticky");
	    }
	});
	
	if ($(document).scrollTop() > 20) {
        $("#scroll-to-top").removeClass("d-none").addClass("d-flex");
    }
});

